import Vue from 'vue';
import Vuex from 'vuex';
import users from './modules/users';
import send from './modules/send';
import follow from './modules/follow';
import contact from './modules/contact';

Vue.use(Vuex);

export default new Vuex.Store({

  modules: {
    users,
    send,
    follow,
    contact
  },

});